import {Paper, Slide, ToggleButton, ToggleButtonGroup, Typography} from "@mui/material";
import React, {useState} from "react";
import View from "../../components/View";
import Page from "../../components/Page";
import BestMixNitrox from "./BestMixNitrox";
import BestMixTrimix from "./BestMixTrimix";

const nitrox = (
    <Paper sx={{m: 2, pt: 1}} elevation={4}>
        <BestMixNitrox/>
    </Paper>
);

const trimix = (
    <Paper sx={{m: 2, pt:1}} elevation={4}>
        <BestMixTrimix/>
    </Paper>
);

export default function BestMix() {

    const [gas, setGas] = useState('nitrox');

    // @ts-ignore
    const handleChangeGas = (event) => {
        setGas(event.target.value)
    }

    return (
        <Page>
            <ToggleButtonGroup
                color="primary"
                value={gas}
                exclusive
                onChange={handleChangeGas}
                aria-label="Platform"
            >
                <ToggleButton value="nitrox">Nitrox</ToggleButton>
                <ToggleButton value="trimix">Trimix</ToggleButton>
            </ToggleButtonGroup>
            <Slide direction="right" in={gas === 'nitrox'} hidden={gas !== 'nitrox'}>
                {nitrox}
            </Slide>
            <Slide direction="right" in={gas === 'trimix'} hidden={gas !== 'trimix'}>
                {trimix}
            </Slide>
            <View>
                <Typography style={{fontWeight: 'bold'}}>Best Mix</Typography>
                <Typography style={{marginTop: 10}}>
                    Is a way of calculating the best mix for a specific depth, and in case of Trimix, END.
                </Typography>
            </View>
        </Page>
    );
}
